import { createStore } from '@stencil/store';

export interface FilterOption {
  title: string;
  value: string;
}

export interface FilterGroup {
  name: string;
  default: string;
  filter: FilterOption[];
}

export interface PropertyInfo {
  name: string;
  address: string;
  location: {
    lat: number;
    lng: number;
  };
  space: string;
  usage: string;
  usageType: string;
  fund: string;
  linkMore: string;
  linkObject: string;
  images: string[];
}

export interface SearchResults {
  currentResults: string;
  totalResults: string;
  hits: PropertyInfo[];
}

export interface SelectedFilters {
  [key: string]: string;
}

const store = createStore({
  filterGroups: [] as FilterGroup[],
  selectedFilters: {} as SelectedFilters,
  searchResults: {} as SearchResults,
  clickedMarkerInfo: {} as PropertyInfo,
  isMarkerPopupOpen: false,
  isMobile: false,
  fetchingData: false,
  fetchingProperties: false,
  loadingMap: false,
  offset: 0,
  resultsPerPage: 6,
  activeView: 'gmaps',
  assetsUrl: '',
  i18n: {} as any,
  noResultMessageTitle: 'Keine Ergebnisse gefunden!',
  noResultMessageHtml: '',
  realEstatePagePath: '/uir-realestate-site/de_DE/object-search/',
  helpers: {
    /**
     * Set icon based on property type.
     * usageType property from api data should be given as a param instead of usage.
     * Returns the icon name.
     */
    setTypeIcon: (usageType: string): string => {
      const icons = {
        office: 'office',
        hotel: 'hotel',
        shopping: 'shopping-bag',
        quarter: 'city-apartment',
        logistic: 'truck',
        living: 'city-apartment',
      };
      return icons[usageType] || 'office';
    },
  },
});

// eslint-disable-next-line import/no-default-export
export default store;
